<div class="announcement-banner" *ngIf="visible" role="status">
  <mat-icon class="banner-icon">campaign</mat-icon>

  <span class="banner-text">
    {{ 'ANNOUNCEMENTS.BANNER_UNREAD' | translate: { count: count } }}
  </span>

  <span class="banner-spacer"></span>

  <button mat-stroked-button class="btn-primary banner-action" (click)="onRead()">
    {{ 'ANNOUNCEMENTS.BANNER_READ' | translate }}
  </button>

  <button mat-icon-button
    class="banner-dismiss"
    (click)="dismiss()"
    [matTooltip]="'ANNOUNCEMENTS.BANNER_DISMISS' | translate"
    [attr.aria-label]="'ANNOUNCEMENTS.BANNER_DISMISS' | translate">
    <mat-icon>close</mat-icon>
  </button>
</div>
